export default "__VITE_ASSET__BGpNdj4m__"